/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  EvaluateOpenAPIv3Form,
  EvaluateOpenAPIv3Form$Outbound,
  EvaluateOpenAPIv3Form$outboundSchema,
} from "../components/evaluateopenapiv3form.js";

export type EvaluateOpenAPIv3SecurityOption1 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type EvaluateOpenAPIv3SecurityOption2 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type EvaluateOpenAPIv3Security = {
  option1?: EvaluateOpenAPIv3SecurityOption1 | undefined;
  option2?: EvaluateOpenAPIv3SecurityOption2 | undefined;
};

export type EvaluateOpenAPIv3Request = {
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  evaluateOpenAPIv3Form: EvaluateOpenAPIv3Form;
};

/** @internal */
export type EvaluateOpenAPIv3SecurityOption1$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const EvaluateOpenAPIv3SecurityOption1$outboundSchema: z.ZodMiniType<
  EvaluateOpenAPIv3SecurityOption1$Outbound,
  EvaluateOpenAPIv3SecurityOption1
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function evaluateOpenAPIv3SecurityOption1ToJSON(
  evaluateOpenAPIv3SecurityOption1: EvaluateOpenAPIv3SecurityOption1,
): string {
  return JSON.stringify(
    EvaluateOpenAPIv3SecurityOption1$outboundSchema.parse(
      evaluateOpenAPIv3SecurityOption1,
    ),
  );
}

/** @internal */
export type EvaluateOpenAPIv3SecurityOption2$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const EvaluateOpenAPIv3SecurityOption2$outboundSchema: z.ZodMiniType<
  EvaluateOpenAPIv3SecurityOption2$Outbound,
  EvaluateOpenAPIv3SecurityOption2
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function evaluateOpenAPIv3SecurityOption2ToJSON(
  evaluateOpenAPIv3SecurityOption2: EvaluateOpenAPIv3SecurityOption2,
): string {
  return JSON.stringify(
    EvaluateOpenAPIv3SecurityOption2$outboundSchema.parse(
      evaluateOpenAPIv3SecurityOption2,
    ),
  );
}

/** @internal */
export type EvaluateOpenAPIv3Security$Outbound = {
  Option1?: EvaluateOpenAPIv3SecurityOption1$Outbound | undefined;
  Option2?: EvaluateOpenAPIv3SecurityOption2$Outbound | undefined;
};

/** @internal */
export const EvaluateOpenAPIv3Security$outboundSchema: z.ZodMiniType<
  EvaluateOpenAPIv3Security$Outbound,
  EvaluateOpenAPIv3Security
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => EvaluateOpenAPIv3SecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => EvaluateOpenAPIv3SecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function evaluateOpenAPIv3SecurityToJSON(
  evaluateOpenAPIv3Security: EvaluateOpenAPIv3Security,
): string {
  return JSON.stringify(
    EvaluateOpenAPIv3Security$outboundSchema.parse(evaluateOpenAPIv3Security),
  );
}

/** @internal */
export type EvaluateOpenAPIv3Request$Outbound = {
  "Gram-Key"?: string | undefined;
  "Gram-Session"?: string | undefined;
  "Gram-Project"?: string | undefined;
  EvaluateOpenAPIv3Form: EvaluateOpenAPIv3Form$Outbound;
};

/** @internal */
export const EvaluateOpenAPIv3Request$outboundSchema: z.ZodMiniType<
  EvaluateOpenAPIv3Request$Outbound,
  EvaluateOpenAPIv3Request
> = z.pipe(
  z.object({
    gramKey: z.optional(z.string()),
    gramSession: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    evaluateOpenAPIv3Form: EvaluateOpenAPIv3Form$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramKey: "Gram-Key",
      gramSession: "Gram-Session",
      gramProject: "Gram-Project",
      evaluateOpenAPIv3Form: "EvaluateOpenAPIv3Form",
    });
  }),
);

export function evaluateOpenAPIv3RequestToJSON(
  evaluateOpenAPIv3Request: EvaluateOpenAPIv3Request,
): string {
  return JSON.stringify(
    EvaluateOpenAPIv3Request$outboundSchema.parse(evaluateOpenAPIv3Request),
  );
}
